export default "__VITE_ASSET__tqJxswB4__"